import { useState } from "react";
import DropMe from "./DropMe"; 
import Footer from "../Footer/Footer";

function Import() {
  const [isUploading, setIsUploading] = useState(false);

  const handleUploadingStatus = (status) => {
    setIsUploading(status);
  };
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-6">
          {!isUploading && (
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Import Product Data
              </h1>
              <p className="text-gray-600">
                Upload your product data files by dragging and dropping them below
              </p>
            </div>
          )}
          
          <div className={`transition-all duration-300 ${isUploading ? 'mt-0' : 'mt-4'}`}>
            <DropMe onUploadingChange={handleUploadingStatus} />
          </div>
          
          {!isUploading && (
             <div className="mt-8 text-center text-sm text-gray-500">
              <p>Supported file types: PDF, CSV, XLSX</p>
              <p className="mt-1">Maximum file size: 10MB</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Import;
